import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	overview: {
		height: 'fit-content'
		// border: '2px solid blue',
	},
	paper: {
		padding: '4rem',
		// backgroundColor: '#CACFD2',
		margin: '1rem',
		height: '100%',
		overflowY: 'scroll',
		textAlign: 'left'
	}
}));
